import { gql } from "@apollo/client";

const getProfileNotesWebsocketTokenQuery = gql`
  query getProfileNotesWebsocketTokenQuery($profileId: Int!) {
    user(userId: $profileId) {
      id
      profilePrivateNotesWebsocketToken
    }
  }
`;

export default getProfileNotesWebsocketTokenQuery;
